import Searchbar from "../Searchbar/Searchbar";
import styles from "./headerSearch.module.css";

export default function SearchInput() {
  return (
    <div className={styles.searchContainer}>
      <Searchbar placeholder="Search for safer alternatives" hideArrow={true} header={true}/>
    </div>
  );
}
